(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  'use strict';

  var D = window.__CartDrawerData || { productData: {}, womenIds: [], menIds: [], moneyFormat: '' };

  var drawer      = document.getElementById('cart-drawer');
  var overlay     = document.getElementById('cart-drawer-overlay');
  var closeBtn    = document.getElementById('cart-drawer-close');
  var itemsEl     = document.getElementById('cart-drawer-items');
  var emptyEl     = document.getElementById('cart-drawer-empty');
  var totalEl     = document.getElementById('cart-drawer-total-amount');
  var recoVert    = document.getElementById('cart-drawer-reco-vertical');
  var recoHoriz   = document.getElementById('cart-drawer-reco-horizontal');
  var recoMobile  = document.getElementById('cart-drawer-reco-mobile');

  if (!drawer) return;

  // ── Money format ──────────────────────────────────────────
  function money(cents) {
    var amt = (cents / 100).toFixed(2);
    return D.moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amt)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amt.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
  }

  // ── Header count bubble ───────────────────────────────────
  function updateCount(n) {
    document.querySelectorAll('.header-icon-btn__count').forEach(function (el) {
      el.textContent = n > 0 ? n : '';
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  // ── Open / close ──────────────────────────────────────────
  function open() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refresh();
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ── Fetch cart and render ─────────────────────────────────
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function (err) { console.error('Cart refresh failed:', err); });
  }

  // ── Main render ───────────────────────────────────────────
  function render(cart) {
    updateCount(cart.item_count);

    var hasItems = cart.item_count > 0;
    if (emptyEl) emptyEl.hidden = hasItems;
    if (itemsEl) itemsEl.innerHTML = hasItems ? renderItems(cart.items) : '';
    if (totalEl) totalEl.textContent = hasItems ? money(cart.total_price) : '—';

    var cartProductIds = cart.items.map(function (i) { return i.product_id; });
    renderRecos(cartProductIds);
  }

  // ── Cart items HTML ───────────────────────────────────────
  function renderItems(items) {
    return items.map(function (item) {
      var imgHtml = item.image
        ? '<img class="cart-item__image" src="' + resizeImg(item.image, '160x') + '" alt="' + xa(item.product_title || item.title) + '" width="80" height="96" loading="lazy">'
        : '<div class="cart-item__image-placeholder"></div>';

      var variantHtml = '';
      if (item.options_with_values && item.options_with_values.length) {
        var opt = item.options_with_values[0];
        if (opt.value && opt.value !== 'Default Title') {
          variantHtml = '<span class="cart-item__variant">' + xe(opt.name) + ' ' + xe(opt.value) + '</span>';
        }
      } else if (item.variant_title && item.variant_title !== 'Default Title') {
        variantHtml = '<span class="cart-item__variant">' + xe(item.variant_title) + '</span>';
      }

      return [
        '<div class="cart-item" data-key="' + xa(item.key) + '">',
          '<div class="cart-item__image-wrap">' + imgHtml + '</div>',
          '<div class="cart-item__content">',
            '<div class="cart-item__top">',
              '<span class="cart-item__name">' + xe(item.product_title || item.title) + '</span>',
              '<button class="cart-item__remove" type="button" aria-label="Remove ' + xa(item.product_title || item.title) + '" data-cd-action="remove" data-cd-key="' + xa(item.key) + '">',
                '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">',
                  '<path d="M11 3L3 11M3 3l8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>',
                '</svg>',
              '</button>',
            '</div>',
            variantHtml,
            '<div class="cart-item__bottom">',
              '<div class="cart-item__stepper">',
                '<button class="cart-item__stepper-btn" type="button" aria-label="Decrease quantity" data-cd-action="qty" data-cd-key="' + xa(item.key) + '" data-cd-qty="' + (item.quantity - 1) + '">−</button>',
                '<span class="cart-item__stepper-qty">' + item.quantity + '</span>',
                '<button class="cart-item__stepper-btn" type="button" aria-label="Increase quantity" data-cd-action="qty" data-cd-key="' + xa(item.key) + '" data-cd-qty="' + (item.quantity + 1) + '">+</button>',
              '</div>',
              '<span class="cart-item__price">' + money(item.final_line_price) + '</span>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');
    }).join('');
  }

  // ── Recommendations ───────────────────────────────────────
  function renderRecos(cartProductIds) {
    var hasWomen = cartProductIds.some(function (id) { return D.womenIds.indexOf(id) !== -1; });
    var hasMen   = cartProductIds.some(function (id) { return D.menIds.indexOf(id) !== -1; });
    var ids      = (hasMen && !hasWomen) ? D.menIds : D.womenIds;
    var visible  = ids.filter(function (id) { return cartProductIds.indexOf(id) === -1; });

    if (recoVert)  recoVert.innerHTML  = visible.map(recoCardHtml).join('');
    if (recoHoriz) recoHoriz.innerHTML = visible.map(recoCardHtmlH).join('');
    if (recoMobile) recoMobile.style.display = visible.length ? '' : 'none';
  }

  function recoCardHtml(id) {
    var p = D.productData[id];
    if (!p) return '';
    var tc  = p.c800 || 'var(--colour-text-primary)';
    var img = p.img ? '<img class="reco-card__image" src="' + p.img + '" alt="' + xa(p.title) + '" loading="lazy">' : '';
    var tagline = p.tagline ? '<p class="reco-card__tagline" style="color:' + tc + '">' + xe(p.tagline) + '</p>' : '';
    var bg = p.c100 || p.c500 || '#F7F4F1';
    return [
      '<a class="reco-card" href="' + p.url + '" style="background:' + bg + '">',
        '<div class="reco-card__image-wrap">' + img + '</div>',
        '<div class="reco-card__info">',
          '<p class="reco-card__name" style="color:' + tc + '">' + xe(p.title) + '</p>',
          tagline,
          '<p class="reco-card__price" style="color:' + tc + '">' + p.price_str + '</p>',
        '</div>',
      '</a>'
    ].join('');
  }

  function recoCardHtmlH(id) {
    var p = D.productData[id];
    if (!p) return '';
    var tc  = p.c800 || 'var(--colour-text-primary)';
    var img = p.img ? '<img class="reco-card__image" src="' + p.img + '" alt="' + xa(p.title) + '" loading="lazy">' : '';
    var bg = p.c100 || p.c500 || '#F7F4F1';
    return [
      '<a class="reco-card reco-card--h" href="' + p.url + '" style="background:' + bg + '">',
        '<div class="reco-card__image-wrap">' + img + '</div>',
        '<div class="reco-card__info">',
          '<p class="reco-card__name" style="color:' + tc + '">' + xe(p.title) + '</p>',
          '<p class="reco-card__price" style="color:' + tc + '">' + p.price_str + '</p>',
        '</div>',
      '</a>'
    ].join('');
  }

  // ── Cart change ───────────────────────────────────────────
  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function () { refresh(); })
    .catch(function (err) {
      console.error('Cart update failed:', err);
      refresh();
    });
  }

  // ── Event delegation ──────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cd-action]');
    if (!btn) return;
    var action = btn.dataset.cdAction;
    var key    = btn.dataset.cdKey;
    if (action === 'remove') {
      changeQty(key, 0);
    } else if (action === 'qty') {
      var qty = parseInt(btn.dataset.cdQty, 10);
      if (qty >= 0) changeQty(key, qty);
    }
  });

  // ── Open triggers ─────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-action="open-cart"]')) open();
  });
  document.addEventListener('cart-drawer:open', open);

  // ── Close bindings ────────────────────────────────────────
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (overlay)  overlay.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      close();
    }
  });

  // ── Shopify add-to-cart hook (refresh on external adds) ──
  document.addEventListener('cart:updated', refresh);

  // ── Public API ────────────────────────────────────────────
  window.CartDrawer = { open: open, close: close, refresh: refresh };

  // ── Helpers ───────────────────────────────────────────────
  function xe(s) {
    return String(s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function xa(s) { return String(s || '').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function resizeImg(url, size) { return (url || '').replace(/(\.[^.?]+)(\?|$)/, '_' + size + '$1$2'); }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function () {
  var CDN_BASE = 'https://cdn.shopify.com/s/files/1/0858/6258/0509/files/';
  var CITIES = [
    'Barcelona_1_jpg.jpg',
    'Berlin_1_jpg.jpg',
    'Dubai_1_jpg.jpg',
    'Hong%20Kong_1_jpg.jpg',
    'London_1_jpg.jpg',
    'Los%20Angeles_1_jpg.jpg',
    'Madrid_1_jpg.jpg',
    'Milan_1_jpg.jpg',
    'NY_1_jpg.jpg',
    'Paris_1_jpg.jpg',
    'Rio%20de%20Janeiro_1_jpg.jpg',
    'Rome_1_jpg.jpg',
    'Shanghai_1_jpg.jpg',
    'Singapore_1_jpg.jpg',
    'Sydney_1_jpg.jpg',
    'Tokyo_1_jpg.jpg'
  ];

  function initCityBanner() {
    var img = document.getElementById('footer-city-img');
    if (!img) return;
    img.src = CDN_BASE + CITIES[Math.floor(Math.random() * CITIES.length)];
  }

  function initAccordion() {
    var headings = document.querySelectorAll('.site-footer__nav-heading[aria-controls]');
    headings.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (window.innerWidth >= 835) return;
        var col = btn.closest('.site-footer__nav-col');
        var isOpen = col.classList.contains('is-open');
        col.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCityBanner();
      initAccordion();
    });
  } else {
    initCityBanner();
    initAccordion();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var burger   = document.querySelector('.site-header__burger');
  var drawer   = document.getElementById('mobile-nav');
  var overlay  = document.querySelector('.mobile-nav-overlay');
  var closeBtn = drawer && drawer.querySelector('.mobile-nav__close');

  if (!burger || !drawer) return;

  // ── Open / close ──────────────────────────────────────────
  function openNav() {
    burger.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeNav() {
    burger.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', function () {
    burger.getAttribute('aria-expanded') === 'true' ? closeNav() : openNav();
  });

  if (closeBtn) closeBtn.addEventListener('click', function () {
    closeNav();
    burger.focus();
  });

  if (overlay) overlay.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
      closeNav();
      burger.focus();
    }
  });

  // ── Icon actions (header + drawer) ───────────────────────
  document.querySelectorAll('[data-action]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      switch (btn.dataset.action) {

        case 'open-chat':
          if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
            window.GorgiasChat.open();
          }
          break;

        case 'open-cart':
          if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
            window.CartDrawer.open();
          } else {
            document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          }
          break;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-care"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHtc(section) {
    var video   = section.querySelector('.htc__video');
    var playBtn = section.querySelector('.htc__play-btn');
    if (!video || !playBtn) return;

    // Unmute synchronously inside user-gesture handler (mobile browsers require this)
    playBtn.addEventListener('click', function () {
      video.muted = false;
      video.volume = 1;
      if (video.paused) { video.play(); }
      playBtn.hidden = true;
    });

    // Click video body to pause / resume
    video.addEventListener('click', function () {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
        playBtn.hidden = false;
      }
    });
  }

  function init() {
    document.querySelectorAll('.htc').forEach(initHtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspired-by"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MOBILE_BP = 835;

  function getVisible() {
    return window.innerWidth < MOBILE_BP ? 5 / 4 : 4;
  }

  function initIby(section) {
    var track   = section.querySelector('[data-iby-track]');
    var items   = Array.from(section.querySelectorAll('[data-iby-item]'));
    var dots    = Array.from(section.querySelectorAll('[data-iby-dot]'));
    var dotNav  = section.querySelector('[data-iby-dot-nav]');
    var prevBtn = section.querySelector('[data-iby-prev]');
    var nextBtn = section.querySelector('[data-iby-next]');

    if (!track || items.length === 0) return;

    var total   = items.length;
    var current = 0;

    function getMax() {
      return window.innerWidth < MOBILE_BP ? total - 1 : 0;
    }

    function updateDots() {
      var max = getMax();
      dots.forEach(function (d, i) {
        d.classList.toggle('iby__dot--hidden', i > max);
        d.classList.toggle('iby__dot--active', i === current);
      });
    }

    function render() {
      var visible = getVisible();
      var pct     = current * (100 / visible);
      track.style.transform = 'translateX(-' + pct + '%)';

      updateDots();

      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= getMax();
    }

    function goTo(index) {
      var next = Math.max(0, Math.min(index, getMax()));
      if (next === current) return;
      current = next;
      render();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    if ('ontouchstart' in window) {
      var touchStartX = 0;
      var touchStartY = 0;
      section.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
      }, { passive: true });
      section.addEventListener('touchend', function (e) {
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        var deltaY = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) goTo(deltaX < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); });
    });

    /* Clamp current index on resize */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        current = Math.min(current, getMax());
        render();
      }, 150);
    });

    render();
  }

  function init() {
    document.querySelectorAll('[data-iby-section]').forEach(initIby);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-iby-section]');
    if (s) initIby(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  'use strict';

  var pageEl   = document.getElementById('cart-page');
  var itemsEl  = document.getElementById('cart-page-items');
  var totalEl  = document.getElementById('cart-page-total');

  if (!pageEl) return;

  var D    = window.__CartPageData || {};
  var i18n = D.i18n || { decreaseQty: 'Decrease quantity', increaseQty: 'Increase quantity', removeItem: 'Remove ' };

  function formatMoney(cents, fmt) {
    fmt = fmt || D.moneyFormat || '{{amount}}';
    var amt     = (cents / 100).toFixed(2);
    var amtND   = String(Math.round(cents / 100));
    var amtComma = amt.replace('.', ',');
    var amtNDComma = amtND;
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, amt)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amtND)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amtComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, amtNDComma);
  }

  function money(cents)             { return formatMoney(cents, D.moneyFormat); }
  function moneyWithCurrency(cents) { return formatMoney(cents, D.moneyWithCurrencyFormat); }

  function xe(s) {
    return String(s || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function xa(s) { return String(s || '').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }

  function resizeImg(url, size) {
    return (url || '').replace(/(\.[^.?]+)(\?|$)/, '_' + size + '$1$2');
  }

  var pendingByKey = {};

  function changeQty(key, qty) {
    if (pendingByKey[key]) return;
    pendingByKey[key] = true;

    // Optimistic DOM update
    if (itemsEl) {
      var itemEl = itemsEl.querySelector('[data-key="' + key + '"]');
      if (itemEl) {
        itemEl.querySelectorAll('.cart-page__stepper-qty').forEach(function (el) {
          el.textContent = qty;
        });
      }
    }

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderPage(cart); })
    .catch(function () { window.location.reload(); })
    .then(function () { pendingByKey[key] = false; });
  }

  function liveQty(itemEl) {
    var el = itemEl && itemEl.querySelector('.cart-page__stepper-qty');
    return el ? (parseInt(el.textContent, 10) || 0) : 0;
  }

  function renderPage(cart) {
    if (totalEl) {
      totalEl.textContent = moneyWithCurrency(cart.total_price);
    }

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      var imgHtml = item.image
        ? '<a href="' + xe(item.url) + '"><img src="' + resizeImg(item.image, '200x') + '" alt="' + xa(item.product_title || item.title) + '" width="100" height="100" loading="lazy"></a>'
        : '<div class="cart-page__item-image-placeholder"></div>';

      var variantHtml = '';
      if (item.options_with_values && item.options_with_values.length) {
        var opt = item.options_with_values[0];
        if (opt.value && opt.value !== 'Default Title') {
          variantHtml = '<span class="cart-page__item-variant">' + xe(opt.name) + ': ' + xe(opt.value) + '</span>';
        }
      } else if (item.variant_title && item.variant_title !== 'Default Title') {
        variantHtml = '<span class="cart-page__item-variant">' + xe(item.variant_title) + '</span>';
      }

      var stepperHtml = [
        '<div class="cart-page__stepper">',
          '<button class="cart-page__stepper-btn" type="button" aria-label="' + xa(i18n.decreaseQty) + '" data-cp-action="qty" data-cp-key="' + xa(item.key) + '" data-cp-qty="dec">−</button>',
          '<span class="cart-page__stepper-qty">' + item.quantity + '</span>',
          '<button class="cart-page__stepper-btn" type="button" aria-label="' + xa(i18n.increaseQty) + '" data-cp-action="qty" data-cp-key="' + xa(item.key) + '" data-cp-qty="inc">+</button>',
        '</div>'
      ].join('');

      var productName = item.product_title || item.title;
      var removeLabel = xa(i18n.removeItem.replace('', xe(productName)));
      var removeBtn = '<button class="cart-page__remove" type="button" aria-label="' + removeLabel + '" data-cp-action="remove" data-cp-key="' + xa(item.key) + '"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>';

      return [
        '<div class="cart-page__item" data-key="' + xa(item.key) + '">',
          '<div class="cart-page__item-image">' + imgHtml + '</div>',
          '<div class="cart-page__item-info">',
            '<a href="' + xe(item.url) + '" class="cart-page__item-name">' + xe(item.product_title || item.title) + '</a>',
            '<span class="cart-page__item-price">' + money(item.price) + '</span>',
            variantHtml,
            '<div class="cart-page__item-controls--mobile">' + stepperHtml + removeBtn + '</div>',
          '</div>',
          '<div class="cart-page__item-qty">' + stepperHtml + removeBtn + '</div>',
          '<div class="cart-page__item-line-price">' + money(item.final_line_price) + '</div>',
        '</div>',
        '<div class="cart-page__divider"></div>'
      ].join('');
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cp-action]');
    if (!btn) return;
    var action  = btn.dataset.cpAction;
    var key     = btn.dataset.cpKey;
    var itemEl  = btn.closest('.cart-page__item');
    if (action === 'remove') {
      changeQty(key, 0);
    } else if (action === 'qty') {
      var delta  = btn.dataset.cpQty === 'inc' ? 1 : -1;
      var newQty = liveQty(itemEl) + delta;
      if (newQty >= 0) changeQty(key, newQty);
    }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signature-details"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSdsr(section) {
    var slides  = Array.from(section.querySelectorAll('[data-sdsr-slide]'));
    var tabs    = Array.from(section.querySelectorAll('[data-sdsr-tab]'));
    var pips    = Array.from(section.querySelectorAll('[data-sdsr-pip]'));
    var prevBtn = section.querySelector('[data-sdsr-prev]');
    var nextBtn = section.querySelector('[data-sdsr-next]');
    var current = 0;
    var total   = slides.length;

    if (total === 0) return;

    function goTo(index) {
      if (index === current) return;

      /* Capture outgoing slide before changing current */
      var outgoing = slides[current];

      /* Deactivate — also strips any in-flight entering class */
      outgoing.classList.remove('sdsr__slide--active', 'sdsr__slide--entering');
      outgoing.setAttribute('aria-hidden', 'true');
      if (tabs[current])  tabs[current].classList.remove('sdsr__tab--active'),  tabs[current].setAttribute('aria-selected', 'false');
      if (pips[current])  pips[current].classList.remove('sdsr__dot-pip--active');

      current = ((index % total) + total) % total;

      /* Capture incoming slide after changing current */
      var incoming = slides[current];

      /* Activate */
      incoming.classList.add('sdsr__slide--active', 'sdsr__slide--entering');
      incoming.setAttribute('aria-hidden', 'false');
      if (tabs[current])  tabs[current].classList.add('sdsr__tab--active'),    tabs[current].setAttribute('aria-selected', 'true');
      if (pips[current])  pips[current].classList.add('sdsr__dot-pip--active');

      /* Remove entering class after animation — closure over local `incoming`,
         not the outer `current`, so rapid switching targets the right slide */
      incoming.addEventListener('animationend', function onEnd() {
        incoming.classList.remove('sdsr__slide--entering');
        incoming.removeEventListener('animationend', onEnd);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        goTo(parseInt(tab.dataset.sdsrTab, 10));
      });
    });

    pips.forEach(function (pip) {
      pip.addEventListener('click', function () {
        goTo(parseInt(pip.dataset.sdsrPip, 10));
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    if ('ontouchstart' in window) {
      var touchStartX = 0;
      var touchStartY = 0;
      section.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
      }, { passive: true });
      section.addEventListener('touchend', function (e) {
        if (e.target.closest('[data-sdsr-tab]')) return;
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        var deltaY = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) goTo(deltaX < 0 ? current + 1 : current - 1);
      }, { passive: true });
    }
  }

  function init() {
    document.querySelectorAll('[data-sdsr-section]').forEach(initSdsr);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-sdsr-section]');
    if (section) initSdsr(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
